import * as React from "react";
import * as moment from "moment";
import { sortBy } from "lodash";
import {
  findFieldValue,
  paystubBasePayFieldPrefixes,
  paystubNonBasePayFieldPrefixes,
} from "web_modules/underwriter_dashboard/shared";

import Money from "web_modules/Money";

const { Panel, Table } = require("react-bootstrap");
const humanize = require("underscore.string/humanize");

interface IPaystubPanelProps {
  docs: any;
  header: string;
  setDocId: Function;
  renderCurrent: Boolean;
  employment: any;
}

const sortPaystubDocsByPaydate = docs => {
  const docsWithPaystubDates = docs.filter(doc => findFieldValue(doc, "pay_period_begin") !== "");
  const docsWithoutPaystubDates = docs.filter(
    doc => findFieldValue(doc, "pay_period_begin") === "",
  );

  return [
    ...sortBy(docsWithPaystubDates, d => -1 * +moment(findFieldValue(d, "pay_period_begin"))),
    ...sortBy(docsWithoutPaystubDates, d => -1 * d.id),
  ];
};

class PaystubPanel extends React.Component<IPaystubPanelProps, any> {
  render() {
    return (
      <Panel defaultExpanded>
        <Panel.Heading>
          <Panel.Title toggle>{this.props.header}</Panel.Title>
        </Panel.Heading>
        <Panel.Collapse>
          <Panel.Body>
            {sortPaystubDocsByPaydate(this.props.docs).map((paystub, i) => (
              <div key={i}>
                {this.renderPaystub(paystub, this.props.employment, this.props.renderCurrent)}
              </div>
            ))}
          </Panel.Body>
        </Panel.Collapse>
      </Panel>
    );
  }

  renderPaystub(doc, employment, renderCurrent) {
    let baseCurrentTotal = 0;
    let baseYtdTotal = 0;
    return (
      <Panel>
        <Table className="income_documents_review_table">
          <thead>
            <tr>
              <th>Source</th>
              <th>Pay Period Start Date</th>
              <th>Pay Period End Date</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <a onClick={this.props.setDocId.bind(this, doc.id)}>Paystub [ID: {doc.id}]</a>
              </td>
              <td>{findFieldValue(doc, "pay_period_begin")}</td>
              <td>{findFieldValue(doc, "pay_period_end")}</td>
            </tr>
          </tbody>
        </Table>
        {paystubBasePayFieldPrefixes.length > 0 && (
          <Table className="income_documents_review_table">
            <thead>
              <tr>
                <th>Base Pay Type</th>
                {renderCurrent && <th>Current Base Earnings</th>}
                <th>Base YTD</th>
              </tr>
            </thead>
            <tbody>
              {paystubBasePayFieldPrefixes.map((fieldPrefix, i) => {
                const description =
                  findFieldValue(doc, `${fieldPrefix}_description`) || fieldPrefix;
                const amount = findFieldValue(doc, `${fieldPrefix}_amount`);
                const ytdAmount = findFieldValue(doc, `${fieldPrefix}_amount_ytd`);
                if (!amount && !ytdAmount) {
                  return null;
                }
                baseCurrentTotal += Number(amount);
                baseYtdTotal += Number(ytdAmount);
                return (
                  <tr key={i}>
                    <td>{humanize(description)}</td>
                    {renderCurrent && (
                      <td>
                        <Money value={amount} />
                      </td>
                    )}
                    <td>
                      <Money value={ytdAmount} />
                    </td>
                  </tr>
                );
              })}
              <tr className="income_documents_review__total_row">
                <td>Base Total</td>
                {renderCurrent && (
                  <td>
                    <Money value={baseCurrentTotal} />
                  </td>
                )}
                <td>
                  <Money value={baseYtdTotal} />
                </td>
              </tr>
            </tbody>
          </Table>
        )}
        <br />
        {paystubNonBasePayFieldPrefixes.reduce(
          (acc, fieldPrefix) => acc + Number(findFieldValue(doc, `${fieldPrefix}_amount_ytd`)),
          0,
        ) > 0 && (
          <Table className="income_documents_review_table">
            <thead>
              <tr>
                <th>Pay Type</th>
                {renderCurrent && <th>Current Earnings</th>}
                <th>YTD</th>
              </tr>
            </thead>
            <tbody>
              {paystubNonBasePayFieldPrefixes.map((fieldPrefix, i) => {
                const description =
                  findFieldValue(doc, `${fieldPrefix}_description`) || fieldPrefix;
                const amount = findFieldValue(doc, `${fieldPrefix}_amount`);
                const ytdAmount = findFieldValue(doc, `${fieldPrefix}_amount_ytd`);
                if (!amount && !ytdAmount) {
                  return null;
                }
                return (
                  <tr key={i}>
                    <td>{humanize(description)}</td>
                    {renderCurrent && (
                      <td>
                        <Money value={amount} />
                      </td>
                    )}
                    <td className="income_documents_review__total_row">
                      <Money value={ytdAmount} />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        )}
      </Panel>
    );
  }
}

export default PaystubPanel;
